export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGOUT_RESET = 'USER_LOGOUT_RESET'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET'

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL'
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET'

export const USER_UPDATE_INFO_REQUEST = 'USER_UPDATE_INFO_REQUEST'
export const USER_UPDATE_INFO_SUCCESS = 'USER_UPDATE_INFO_SUCCESS'
export const USER_UPDATE_INFO_FAIL = 'USER_UPDATE_INFO_FAIL'
export const USER_UPDATE_INFO_RESET = 'USER_UPDATE_INFO_RESET'

export const USER_ADMIN_COMPLETE_SIGNUP_REQUEST =
  'USER_ADMIN_COMPLETE_SIGNUP_REQUEST'
export const USER_ADMIN_COMPLETE_SIGNUP_SUCCESS =
  'USER_ADMIN_COMPLETE_SIGNUP_SUCCESS'
export const USER_ADMIN_COMPLETE_SIGNUP_FAIL = 'USER_ADMIN_COMPLETE_SIGNUP_FAIL'
export const USER_ADMIN_COMPLETE_SIGNUP_RESET =
  'USER_ADMIN_COMPLETE_SIGNUP_RESET'

export const USER_ADMIN_UPDATE_INFO_REQUEST = 'USER_ADMIN_UPDATE_INFO_REQUEST'
export const USER_ADMIN_UPDATE_INFO_SUCCESS = 'USER_ADMIN_UPDATE_INFO_SUCCESS'
export const USER_ADMIN_UPDATE_INFO_FAIL = 'USER_ADMIN_UPDATE_INFO_FAIL'
export const USER_ADMIN_UPDATE_INFO_RESET = 'USER_ADMIN_UPDATE_INFO_RESET'

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
export const USER_LIST_FAIL = 'USER_LIST_FAIL'
export const USER_LIST_RESET = 'USER_LIST_RESET'

export const USER_ADMIN_LIST_REQUEST = 'USER_ADMIN_LIST_REQUEST'
export const USER_ADMIN_LIST_SUCCESS = 'USER_ADMIN_LIST_SUCCESS'
export const USER_ADMIN_LIST_FAIL = 'USER_ADMIN_LIST_FAIL'
export const USER_ADMIN_LIST_RESET = 'USER_ADMIN_LIST_RESET'

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL'
export const USER_DELETE_RESET = 'USER_DELETE_RESET'

export const USER_CONFIRM_VALIDATION_REQUEST = 'USER_CONFIRM_VALIDATION_REQUEST'
export const USER_CONFIRM_VALIDATION_SUCCESS = 'USER_CONFIRM_VALIDATION_SUCCESS'
export const USER_CONFIRM_VALIDATION_FAIL = 'USER_CONFIRM_VALIDATION_FAIL'
export const USER_CONFIRM_VALIDATION_RESET = 'USER_CONFIRM_VALIDATION_RESET'

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS'
export const USER_RESET_PASSWORD_FAIL = 'USER_RESET_PASSWORD_FAIL'
export const USER_RESET_PASSWORD_RESET = 'USER_RESET_PASSWORD_RESET'

export const USER_RESET_PASSWORD_LINK_REQUEST = 'USER_RESET_PASSWORD_LINK_REQUEST'
export const USER_RESET_PASSWORD_LINK_SUCCESS = 'USER_RESET_PASSWORD_LINK_SUCCESS'
export const USER_RESET_PASSWORD_LINK_FAIL = 'USER_RESET_PASSWORD_LINK_FAIL'
export const USER_RESET_PASSWORD_LINK_RESET = 'USER_RESET_PASSWORD_LINK_RESET'

export const USER_UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST'
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS'
export const USER_UPDATE_PASSWORD_FAIL = 'USER_UPDATE_PASSWORD_FAIL'
export const USER_UPDATE_PASSWORD_RESET = 'USER_UPDATE_PASSWORD_RESET'

export const USER_DEACTIVATE_REQUEST = 'USER_DEACTIVATE_REQUEST'
export const USER_DEACTIVATE_SUCCESS = 'USER_DEACTIVATE_SUCCESS'
export const USER_DEACTIVATE_FAIL = 'USER_DEACTIVATE_FAIL'
export const USER_DEACTIVATE_RESET = 'USER_DEACTIVATE_RESET'

export const USER_ACTIVATE_REQUEST = 'USER_ACTIVATE_REQUEST'
export const USER_ACTIVATE_SUCCESS = 'USER_ACTIVATE_SUCCESS'
export const USER_ACTIVATE_FAIL = 'USER_ACTIVATE_FAIL'
export const USER_ACTIVATE_RESET = 'USER_ACTIVATE_RESET'

export const USER_INVITE_REQUEST = 'USER_INVITE_REQUEST'
export const USER_INVITE_SUCCESS = 'USER_INVITE_SUCCESS'
export const USER_INVITE_FAIL = 'USER_INVITE_FAIL'
export const USER_INVITE_RESET = 'USER_INVITE_RESET'
